import { Lock } from 'lucide-react'
import { useAuth } from '../auth/context'
import { Button } from '../components/Button'
import { getWebApp, isInTelegram } from '../telegram'
import { AuthLayout } from './AuthLayout'

export function NoAccessScreen({ hadInvite }: { hadInvite: boolean }) {
  const { signOut } = useAuth()
  const inTelegram = isInTelegram()

  return (
    <AuthLayout>
      <div className="flex flex-col items-center text-center">
        <span className="mb-3 inline-flex size-11 items-center justify-center rounded-xl bg-surface text-muted ring-1 ring-line ring-inset">
          <Lock size={20} />
        </span>
        <h1 className="page-title">Нет доступа</h1>
        <p className="mt-1 text-sm text-pretty text-muted">
          {hadInvite
            ? 'Приглашение не сработало: возможно, ссылка устарела. Попросите владельца прислать новую.'
            : 'Этого аккаунта нет в команде. Попросите владельца прислать ссылку-приглашение и откройте её.'}
        </p>
        <div className="mt-6">
          {inTelegram ? (
            <Button onClick={() => getWebApp()?.close()}>Закрыть</Button>
          ) : (
            <Button onClick={signOut}>Войти другим аккаунтом</Button>
          )}
        </div>
      </div>
    </AuthLayout>
  )
}
